import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PaymentPage from "./pages/payment/PaymentPage";
import TestErrorPage from "./pages/error/TestErrorPage";
import ProdErrorPage from "./pages/error/ProdErrorPage";
import VposPayment from "./pages/vpos/VposPaymentPage";
import NotFoundPage from "./pages/NotFoundPage";
import RecurringPaymentPage from "./pages/recurring/RecurringPaymentPage";

const AppRouter = () => {
  return (
    <Router>
      <Switch>
        <Route path="/charge/:id" component={PaymentPage} />
        <Route path="/recurring/:id" component={RecurringPaymentPage} />
        <Route path="/vpos/charge/:id" component={VposPayment} />
        <Route path="/error/:id/:code" component={TestErrorPage} />
        <Route exact path="/error" component={ProdErrorPage} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
